import Vue from 'vue'
import Vuex from 'vuex'
import FactoringDocumentService from '@/services/FactoringDocumentService'
import SurveyAnswerService from '@/services/SurveyAnswerService'
import ProductService from '@/services/ProductService.js'
import CreditsManagerService from '@/services/CreditsManagerService'
import SATService from '@/services/SATService'
import Utils from '@/common/utils'
import Status from '@/common/FactoringDocumentStatus.js'
import { GEN_RFC } from '@/common/constantes.js'
import ClientBranch from '../common/ClientBranch'
import SessionService from '../services/SessionService'

Vue.use(Vuex)

const getDefaultState = () => ({
  isLoggedIn: false,
  exchageRate: 0,
  user: {},
  invoices: [],
  invoicesGroups: [],
  nextPayments: [],
  creditsInformation: [],
  products: {},
  creditsGroups: {
    BI: null,
    FB: null
  },
  isAuthBI: false, // Tiene el producto?
  isActiveBI: false, // Tiene el producto activo? (subida de facturas)
  isAuthFB: false,
  isActiveFB: false,
  hasBIMXNAccount: false,
  hasFBMXNAccount: false,
  hasBIUSDAccount: false,
  hasFBUSDAccount: false,
  survey: [],
  isLoading: false,
  indicators: {},
  activePortafolio: [],
  closedPortafolio: []
})

export default new Vuex.Store({
  state: getDefaultState(),

  mutations: {
    SET_USER: function (state, user) {
      state.user = user
    },
    SET_LOGGED_IN: function (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    SET_NOT_AUTH: function (state) {
      state.isLoggedIn = false
      state.user = {}
    },
    SET_INVOICES: function (state, items) {
      state.invoices = items
    },
    ADD_INVOICES: function (state, items) {
      state.invoices = [...state.invoices, ...items]
    },
    SET_INVOICE: function (state, item) {
      if (item) {
        const exist = state.invoices.findIndex(invoice => invoice.uuid === item.uuid)
        if (exist > 0) {
          state.invoices[exist] = { ...item }
        } else {
          state.invoices.push(item)
        }
      }
    },
    UPDATE_INVOICE: function (state, item) {
      if (item) {
        const invoice = state.invoices.find(invoice => invoice.uuid === item.uuid)
        if (invoice) {
          state.invoices = state.invoices.filter(invoice => invoice.uuid !== item.uuid)
          state.invoices.push(item)
          // invoice = Object.assign({}, item)
        }
      }
    },
    SET_CREDIT_AUTH: function (state) {
      // Check if the Client has the product
      const someBI = state.creditsInformation.some(credit => credit.product === 'BI')
      const someFB = state.creditsInformation.some(credit => credit.product === 'FB')

      if (someBI) { state.isAuthBI = true }
      if (someFB) { state.isAuthFB = true }

      // Check if the product is active
      const activeBI = state.creditsInformation.some(credit => credit.product === 'BI' && credit.autorizado === true)
      const activeFB = state.creditsInformation.some(credit => credit.product === 'FB' && credit.autorizado === true)

      state.hasBIMXNAccount = state.creditsInformation.some(credit => credit.moneda === 'MXN' && credit.hasBankAccount && credit.product === 'BI')
      state.hasBIUSDAccount = state.creditsInformation.some(credit => credit.moneda === 'USD' && credit.hasBankAccount && credit.product === 'BI')
      state.hasFBMXNAccount = state.creditsInformation.some(credit => credit.moneda === 'MXN' && credit.hasBankAccount && credit.product === 'FB')
      state.hasFBUSDAccount = state.creditsInformation.some(credit => credit.moneda === 'USD' && credit.hasBankAccount && credit.product === 'FB')

      if (activeBI) { state.isActiveBI = true }
      if (activeFB) { state.isActiveFB = true }
    },
    SET_CREDITS_INFORMATION: function (state, items) {
      state.creditsInformation = []
      state.creditsInformation = items.map(item => item)
    },
    SET_CREDIT_GROUP: function (state, paylaod) {
      state.creditsGroups[paylaod.product] = paylaod.items.map(item => item)
    },
    UPDATE_CREDIT_INVOICES: function (state, paylaod) {
      const invoices = state.invoices.filter(invoice => invoice.status !== Status.CREDITO)
      state.invoices = [...invoices, ...paylaod]
    },
    UPDATE_INVOICES_BY_STATUS: function (state, paylaod) {
      if (paylaod.invoices) {
        const status = paylaod.status
        const invoicesToUpdate = paylaod.invoices
        const invoices = state.invoices.filter(invoice => invoice.status !== status)
        state.invoices = [...invoices, ...invoicesToUpdate]
      }
    },
    UPDATE_INVOICESGROUPS: function (state, firstLoad = false) {
      firstLoad = false
      state.invoicesGroups = []
      let genericRFCInvoices = []
      let syncGenericRFCInvoices = []
      let syncInvoicesGroups = []
      if (firstLoad) { // not usefull yet
        genericRFCInvoices = state.invoices.filter(invoice => invoice.receiverRFC === GEN_RFC && (
          invoice.status === Status.AUTORIZADA ||
          invoice.status === Status.REGISTRADO ||
          invoice.status === Status.PREVENTA ||
          invoice.status === Status.RECHAZADA
        ))
        state.invoicesGroups = Utils.groupBy(state.invoices.filter(invoice =>
          invoice.status === Status.AUTORIZADA ||
          invoice.status === Status.REGISTRADO ||
          invoice.status === Status.PREVENTA ||
          invoice.status === Status.RECHAZADA
        ), invoice => invoice.receiverRFC)
          .map(group => Object.assign({}, { receiverRFC: group.values[0].receiverRFC, invoices: group.values }))
      } else {
        // Clientes extranjeros
        genericRFCInvoices = state.invoices.filter(invoice => invoice.receiverRFC === GEN_RFC && !invoice.isSync && (
          invoice.status === Status.AUTORIZADA ||
          invoice.status === Status.REGISTRADO ||
          invoice.status === Status.PREVENTA ||
          invoice.status === Status.RECHAZADA
        ))
        syncGenericRFCInvoices = state.invoices.filter(invoice => invoice.receiverRFC === GEN_RFC && invoice.isSync && (
          invoice.status === Status.AUTORIZADA ||
          invoice.status === Status.REGISTRADO ||
          invoice.status === Status.PREVENTA ||
          invoice.status === Status.RECHAZADA
        ))
        // Clientes nacioonales
        state.invoicesGroups = Utils.groupBy(state.invoices.filter(invoice => invoice.receiverRFC !== GEN_RFC && !invoice.isSync &&
        (invoice.status === Status.AUTORIZADA ||
              invoice.status === Status.REGISTRADO ||
              invoice.status === Status.PREVENTA ||
              invoice.status === Status.RECHAZADA
        )), invoice => invoice.receiverRFC).map(group => Object.assign({}, { receiverRFC: group.values[0].receiverRFC, invoices: group.values, isSyncGroup: false }))
        syncInvoicesGroups = Utils.groupBy(state.invoices.filter(invoice => invoice.receiverRFC !== GEN_RFC && invoice.isSync &&
          (invoice.status === Status.AUTORIZADA ||
                invoice.status === Status.REGISTRADO ||
                invoice.status === Status.PREVENTA ||
                invoice.status === Status.RECHAZADA
          )), invoice => invoice.receiverRFC).map(group => Object.assign({}, { receiverRFC: group.values[0].receiverRFC, invoices: group.values, isSyncGroup: true }))
      }

      const genericGroups = Utils.groupBy(genericRFCInvoices, invoice => invoice.receiverName.toLowerCase()).map(group => Object.assign({}, { receiverRFC: group.values[0].receiverRFC, invoices: group.values, isSyncGroup: false }))
      const syncGenericGroups = Utils.groupBy(syncGenericRFCInvoices, invoice => invoice.receiverName.toLowerCase()).map(group => Object.assign({}, { receiverRFC: group.values[0].receiverRFC, invoices: group.values, isSyncGroup: true }))

      state.invoicesGroups = [...state.invoicesGroups, ...syncInvoicesGroups, ...genericGroups, ...syncGenericGroups]
      const firstUSDCredit = state.creditsInformation ? state.creditsInformation.find(item => item.moneda === 'USD') : {}
      state.exchageRate = firstUSDCredit ? firstUSDCredit.tipoCambio || 19 : 19
      state.invoicesGroups = state.invoicesGroups.map(group => {
        const totalMXN = group.invoices.filter(invoice =>
          invoice.currency === 'MXN' &&
          (invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO)
        )
        const totalUSD = group.invoices.filter(invoice =>
          invoice.currency === 'USD' &&
          (invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO)
        )
        const groupObject = {
          receiverName: group.invoices[0].receiverName,
          receiverRFC: group.receiverRFC,
          totalMXN: parseFloat(totalMXN.length > 0 ? totalMXN.map(invoice => invoice.total).reduce((accum, value) => parseFloat(accum) + parseFloat(value)) : 0),
          totalUSD: parseFloat(totalUSD.length > 0 ? totalUSD.map(invoice => invoice.total).reduce((accum, value) => parseFloat(accum) + parseFloat(value)) : 0),
          total: 0,
          paymentDays: group.paymentDays || { paymentDays: 0, weekDays: { monday: false, tuesday: false, wednesday: false, thursday: false, friday: false } },
          invoices: group.invoices,
          hasBI: group.invoices.some(invoice => invoice.productId === state.products.BI.productId && (invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO)),
          hasFB: group.invoices.some(invoice => invoice.productId === state.products.FB.productId && (invoice.status === Status.AUTORIZADA || invoice.status === Status.REGISTRADO)),
          errors: { general: null, invoices: [] },
          errorsPO: { general: null, invoices: [] },
          isSyncGroup: group.isSyncGroup
        }
        groupObject.total = groupObject.totalMXN + (groupObject.totalUSD * state.exchageRate)
        return Object.assign({}, groupObject)
      })
      state.invoicesGroups = state.invoicesGroups.sort((a, b) => a.total === b.total ? 0 : a.total > b.total ? -1 : 1)
      const invoicesTotal = state.invoicesGroups.map(group => group.total)
      const total = invoicesTotal.length > 0 ? parseFloat(invoicesTotal.reduce((accum, groupTotal) => parseFloat(accum) + parseFloat(groupTotal))) : 0
      if (total) {
        // state.invoicesGroups[i].config = Utils.Quartile(state.invoicesGroups, i, total) || 1
        let currentQuartile = 1
        const thresholds = [0, 0.25, 0.5, 0.75, 1]
        let percentageAccum = 0
        let percentage = 0
        for (let i = 0; i < state.invoicesGroups.length; i++) {
          percentage = state.invoicesGroups[i].total / total
          percentageAccum += percentage
          if (percentageAccum <= thresholds[currentQuartile]) {
            state.invoicesGroups[i].config = currentQuartile
          } else {
            state.invoicesGroups[i].config = currentQuartile
            currentQuartile = currentQuartile < 4 ? currentQuartile + 1 : currentQuartile
          }
        }
      }
      state.invoicesGroups = state.invoicesGroups.sort((a, b) => a.total === b.total ? 0 : a.total < b.total ? 1 : -1)
    },
    SET_NEXT_PAYMENTS: function (state, items = []) {
      state.nextPayments = items.map(item => item)
    },
    // PUSH_PAYMENT_REFERENCE: function (state, item) {
    //   if (state.user.client.paymentReferences) {
    //     let exist = state.user.client.paymentReferences.some(reference => reference.reference === item.reference)
    //     if (!exist) {
    //       state.user.client.paymentReferences.push(item)
    //     }
    //   }
    // },
    SET_PRODUCT: function (state, item) {
      if (item) {
        if (item.code) {
          state.products[item.code] = item
        }
      }
    },
    SET_SURVEY: function (state, survey) {
      state.survey = survey
    },

    CLEAR (state) {
      Object.assign(state, getDefaultState())
    },
    SET_ACTIVE_PORTAFOLIO (state, items) {
      state.activePortafolio = items
    },
    SET_CLOSED_PORTAFOLIO (state, items) {
      state.closedPortafolio = items
    },
    SET_INDICATORS (state, items) {
      state.indicators = items
    }
  },
  actions: {
    async login ({ commit }, { username, password }) {
      try {
        commit('CLEAR')
        const { user } = await SessionService.login({ username, password })
        user.client.promoterPhone = user.client.branch === ClientBranch.BLUE ? process.env.VUE_APP_BLU_WHATSAPP_BLUE : process.env.VUE_APP_BLU_WHATSAPP_GREEN
        commit('SET_USER', user)
        commit('SET_LOGGED_IN', true)
        return
      } catch (error) {
        commit('SET_NOT_AUTH')
        throw error.response
      }
    },
    async logout ({ commit }) {
      try {
        const { status } = await SessionService.logout()
        if (status === 'success') commit('CLEAR')
        return
      } catch (error) {
        console.error(error)
      }
    },
    setUser ({ commit }, { user, isLoggedIn }) {
      commit('SET_LOGGED_IN', isLoggedIn)
      commit('SET_USER', user)
    },
    updateInvoicesGroups ({ commit }) {
      commit('UPDATE_INVOICESGROUPS')
    },
    async updateCreditInvoices ({ commit }, creditInvoices) {
      commit('UPDATE_CREDIT_INVOICES', creditInvoices)
      commit('UPDATE_INVOICESGROUPS')
    },
    async setInvoices ({ commit }) {
      const params = {
        clientId: this.state.user.clientId,
        products: [
          this.state.products.BI.productId,
          this.state.products.FB.productId
        ],
        status: [
          Status.RECHAZADA,
          Status.REGISTRADO,
          Status.AUTORIZADA,
          Status.PREVENTA
        ],
        sevenDaysRejectedDate: true
      }

      try {
        // Se obtienen las facturas que no estan en crédito
        const invoices = await FactoringDocumentService.getDocuments(params)

        // Se obtienen las facturas que si estan en crédito, pero que aun no han sido pagadas por el cliente
        params.status = [Status.CREDITO]
        params.withoutPaymentDate = true
        delete params.sevenDaysRejectedDate

        const creditInvoices = await FactoringDocumentService.getDocuments(params)
        const allInvoices = [...invoices.data, ...creditInvoices.data]

        commit('SET_INVOICES', allInvoices)
        commit('UPDATE_INVOICESGROUPS')
      } catch (error) {
        console.error(error)
      }
    },
    async updateInvoicesByStatus ({ commit }, { invoices, status }) {
      commit('UPDATE_INVOICES_BY_STATUS', { invoices, status })
      commit('UPDATE_INVOICESGROUPS')
    },
    setInvoice ({ commit }, { data, firstLoad = false }) {
      commit('SET_INVOICE', data)
      commit('UPDATE_INVOICESGROUPS', {
        firstLoad: firstLoad
      })
    },
    async setPreSellInvoices ({ commit, getters, dispatch }, { data }) {
      return true
      // try {
      //   let { docs } = await FactoringDocumentService.preSell({
      //     invoices: data.invoices,
      //     client: data.client
      //   })
      //   for (let invoice of data.invoices) {
      //     let doc = docs.find(doc => doc.uuid === invoice.uuid)
      //     if (doc) {
      //       commit('UPDATE_INVOICE', doc)
      //     }
      //   }
      //   commit('UPDATE_INVOICESGROUPS')

      //   let params = { emitterRFC: getters.user.client.rfc, products: ['BI', 'FB'] }
      //   await dispatch('setCreditsInformation', params)
      // } catch (error) {
      //   console.info(error)
      // }
    },
    async setNextPayments ({ commit, state }, params) {
      try {
        let { items } = await FactoringDocumentService.nextPayments({ clientId: state.user.clientId, productId: state.products.BI.productId })
        items = items.sort((a, b) => a.dueDate === b.dueDate ? 0 : a.dueDate < b.dueDate ? 1 : -1)
        commit('SET_NEXT_PAYMENTS', items)
      } catch (error) {
        console.info(error)
      }
    },
    async setCreditsInformation ({ commit, state }, params) {
      let data = []
      const products = params.products.map(product => product)
      delete params.products
      for (const product of products) {
        params.product = product
        try {
          let response = await CreditsManagerService.getCreditInformation(params)

          const productId = product === 'FB' ? state.products.FB.productId : state.products.BI.productId
          response = typeof response === 'string' ? [] : response.map(info => Object.assign(info, { product: params.product }, { productId: productId }))
          commit('SET_CREDIT_GROUP', { productId: productId, product: product, items: response })
          if (response.length > 0) {
            data.push(response)
          }
        } catch (error) {
          if (error.name !== 'Error') {
            console.info(error.stack)
            console.info(error.name)
            console.info(error.message)
          }
        }
      }
      data = data.map(credit => credit).flat()
      commit('SET_CREDITS_INFORMATION', data)
      commit('SET_CREDIT_AUTH')
    },
    // pushPaymentReference ({ commit }, item) {
    //   commit('PUSH_PAYMENT_REFERENCE', item)
    // },
    async SatSync ({ commit, getters, dispatch }) {
      try {
        const clientId = getters.user.clientId
        // TODO: En vez de mandar llamar esta funcion, mandar al endpoint del risk update to date con header de clientuserid
        SATService.syncInvoices({ clientId })
        const user = getters.user
        user.SATdownloading = true
        commit('SET_USER', user)
      } catch (error) {
        console.error(error)
      }
    },
    async setProducts ({ commit }) {
      const products = {}
      try {
        const { data } = await ProductService.getProducts()
        if (data.length > 0) {
          for (const product of data) {
            commit('SET_PRODUCT', product)
          }
        }
        return products
      } catch (error) {
        console.error(error)
        return products
      }
    },
    async survey ({ commit }) {
      if (this.state.user.userId) {
        try {
          const { data } = await SurveyAnswerService.getForUser(this.state.user.userId)
          commit('SET_SURVEY', data)
          return
        } catch (error) {
          console.error('error', error)
          throw error.response
        }
      }
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    products: state => state.products,
    user: state => state.user,
    invoices: state => state.invoices,
    invoicesGroups: state => state.invoicesGroups,
    nextPayments: state => state.nextPayments,
    creditsInformation: state => state.creditsInformation,
    creditsGroups: state => state.creditsGroups,
    isAuthBI: state => state.isAuthBI,
    isAuthFB: state => state.isAuthFB,
    isActiveBI: state => state.isActiveBI,
    isActiveFB: state => state.isActiveFB,
    hasBIMXNAccount: state => state.hasBIMXNAccount,
    hasBIUSDAccount: state => state.hasBIUSDAccount,
    hasFBMXNAccount: state => state.hasFBMXNAccount,
    hasFBUSDAccount: state => state.hasFBUSDAccount,
    survey: state => state.survey
  },
  modules: {}
})
